import apiResponse from '@stores/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { Duration } from 'luxon';
import { GroupStore } from '@app/api/GroupStore';
import { CohortUser } from '@app/models/CohortUser';

/** Weekly goal and progress data for a single week */
interface WeeklyData {
  /** Zero-indexed week number */
  week: number;
  /** Total goal activities for this week (sum of all goal frequencies) */
  goalCount: number;
  /** Total recorded activities for this week */
  progressCount: number;
}

/** Aggregated weekly data for a cohort user */
interface CohortUserWeeklyData {
  cohortUser: CohortUser;
  weeks: WeeklyData[];
}

export interface AllCohortUserWeeklyData {
  /** Array of cohort users with their weekly data */
  cohortUsersWeeklyData: CohortUserWeeklyData[];
  /** Zero-indexed current week number for the cohort */
  currentWeekNumber: number;
}

export class AdminEngagementReportViewCreator {
  constructor(private readonly store: GroupStore = new GroupStore()) {}

  async createView(groupId: number) {
    const result = await apiResponse.handleApiResponse<AllCohortUserWeeklyData>(
      async () => await this.store.AdminGetEngagementReport(groupId)
    );

    return result as AllCohortUserWeeklyData;
  }
}

export const useAdminEngagementReportViewCreator = (groupId: number, enabled: boolean = true) =>
  useQuery({
    queryKey: [AdminEngagementReportViewCreator.name, groupId],
    queryFn: () => new AdminEngagementReportViewCreator().createView(groupId),
    staleTime: Duration.fromObject({ minutes: 1 }).milliseconds,
    enabled: enabled && groupId > 0,
  });
